<template>
  <div v-if="errors && errors[field]">
    <p
      v-for="error in errors[field]"
      :key="error"
      class="el-form-item__help el-form-item__help--alert"
    >
      <i class="el-icon-error" />
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FieldError',
  props: {
    errors: {
      type: Object,
      default: null,
    },
    field: {
      type: String,
      required: true,
    },
  },
};
</script>
